import { useUserValidations } from '@/composables/useUserValidations';

export default function (): boolean {
  const { $debug } = useNuxtApp();

  try {
    const { isSmsIntegrationEnabled } = useFeatureFlagsJson();
    const { isNewUserToValidate } = useUserData();
    const { userPhone, userPhoneDdi } = useUserData();

    if (!isSmsIntegrationEnabled.value) {
      const checkPhoneRules = computed(() => {
        if (isNewUserToValidate.value) {
          return !!userPhone.value && !!userPhoneDdi.value;
        }

        return true;
      });

      if ($debug.isEnabled) {
        console.groupCollapsed('🗺️ ~ PHONE VALIDATION:\n');
        console.debug('🗺️ ~ userPhone:', userPhone.value);
        console.debug('🗺️ ~ userPhoneDdi:', userPhoneDdi.value);
        coloredDebug(checkPhoneRules.value);
        console.groupEnd();
      }

      return checkPhoneRules.value;
    }

    const { isSmsVerified } = useUserValidations();

    const checkSmsRules = computed(() => {
      if (isNewUserToValidate.value) {
        return isSmsVerified.value && !!userPhone.value && !!userPhoneDdi.value;
      }

      return true;
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('📱 ~ SMS VALIDATION:\n');
      console.debug('📱 ~ isSmsVerified:', isSmsVerified.value);
      console.debug('🗺️ ~ userPhone:', userPhone.value);
      console.debug('🗺️ ~ userPhoneDdi:', userPhoneDdi.value);
      console.debug(
        '📱 ~ isSmsIntegrationEnabled:',
        isSmsIntegrationEnabled.value,
      );
      coloredDebug(checkSmsRules.value);
      console.groupEnd();
    }

    return checkSmsRules.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.error(err);
    }

    return false;
  }
}
